export default __webpack_public_path__ + "static/media/Jeams.aed83b26.png";